import { saveAs } from 'file-saver';
import { PriceRequestService } from '../../../../../api/priceRequest.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '@app/../environments/environment'
@Component({
  selector: 'meu-app-get-quote-note',
  templateUrl: './app-get-quote-note.component.html',
  styleUrls: ['./app-get-quote-note.component.scss']
})
export class AppGetQuoteNoteComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AppGetQuoteNoteComponent>,
    public PriceRequestService: PriceRequestService,
  ) { }
  proceed: boolean = false;
  lstFile: any = [];
  lstFileDelete: any = [];
  ngOnInit() {
    this.getQuoteNoteByID();

  }
  cancelModal() {
    this.dialogRef.close();
  }
  downloadFile(url, name) {
    if (url.includes("png") || url.includes("jpg") || url.includes("jpeg") || url.includes("pdf")) {

      window.open(environment.backendhost + url);
    }
    else {
      var blob = new Blob([url]);
      saveAs(blob, name);
    }

  }
  getQuoteNoteByID() {
    this.PriceRequestService.apiPriceRequestsIdGet(this.data.quote.id).subscribe(res => {
      if (res.success) {
        if (res.data.attachments != null) {
          for (let i = 0; i < this.data.quote.attachments.length; i++) {
            this.lstFile.push({
              url: this.data.quote.attachments[i],
              name: this.data.quote.attachments[i].split("/")[3],
            })
          }
        }
      }
    })
  }
  appoveRequest() {
    // this.data.order.proceed = this.proceed;
    this.data.quote.attachments = [];
    this.PriceRequestService.apiPriceRequestsIdPut(this.data.quote.id, this.data.quote).subscribe(
      res => {
        if (res.success) {
          if (this.lstFileDelete.length > 0) {
            for (let i = 0; i < this.lstFileDelete.length; i++) {
              this.PriceRequestService.apiPriceRequestsIdFilePost(res.data.id, this.lstFileDelete[i]).subscribe(res => {

              })
            }
          }
          if (this.lstFile.length > 0) {
            for (let i = 0; i < this.lstFile.length; i++) {
              if (this.lstFile[i].url == undefined) {

                let file: File = this.lstFile[i];

                this.PriceRequestService.apiPriceRequestsIdFilePut(res.data.id, file).subscribe(resFile => {
                  if (resFile.success && i + 1 == this.lstFile.length) {
                    this.dialogRef.close({ event: true, item: res.data });
                  }
                })
              }
              else {
                if (i + 1 == this.lstFile.length) {
                  this.dialogRef.close({ event: true, item: res.data });
                }

              }

            }

          }
          else {
            this.dialogRef.close({ event: true, item: res.data });
          }

        }
      })
  }
  //file 
  onFileInput(ev) {
    const file = ev.target.files[0];
    if (file != undefined) {
      this.lstFile.push(file);
    }
  }
  getIconFile(name) {
    let typeName = name.split(".")[1];
    if (typeName.includes("png") || typeName.includes("jpg") || typeName.includes("jpeg")) {
      return "file-image.svg"
    }
    if (name.includes("doc") || name.includes("docx")) {
      return "file-word.svg"
    }
    if (name.includes("xlsx")) {
      return "file-excel.svg"
    }
    if (name.includes("pdf")) {
      return "file-pdf.svg"
    }

    return "file-other.svg"
  }
  deletefile(index) {
    this.lstFileDelete.push(this.lstFile[index]);
    this.lstFile.splice(index, 1)

  }
  //end file 
}
